import { render, staticRenderFns } from "./InstitutionEdit.vue?vue&type=template&id=1921b82a&scoped=true&"
import script from "./InstitutionEdit.vue?vue&type=script&lang=js&"
export * from "./InstitutionEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionEdit.vue?vue&type=style&index=0&id=1921b82a&lang=less&scoped=true&"
import style1 from "./InstitutionEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921b82a",
  null
  
)

export default component.exports